import React, { useEffect } from "react";

import { Dialog } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import MinCountDown from "../../reusableComponents/allPopupReusable/tableNumberPopup/MinCountDown";

function SessionExpiry(props) {
  // const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (props?.open) {
      handleClickOpen();
    } else {
      handleClose()
    }
  }, [props?.open]);

  const handleClose = () => {
    setOpen(false);
  };



  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <DialogContent className="text-center">
          <DialogContentText id="alert-dialog-description">
            <div className="f16-700">Your Session will Expire Soon!</div>
            <div className="mt-2 f12-400">
              Your session will time out in 5 minutes.{" "}
              <br />
              Please restart your work.
            </div>
            <div className="mt-3 c_red">
              <MinCountDown waitNew={props.timeLeft} />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

// const SessionPopupComponent = (props) => (
//   <SocketContext.Consumer>
//     {(socket) => <SessionPopup {...props} socket={socket} />}
//   </SocketContext.Consumer>
// );

export default SessionExpiry;

